import Vue from 'vue';
import { formatField } from '@/src/utils/value-formatter/formatting-service';

Vue.filter('formatField', formatField);
